import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAuthContext } from '../auth/AuthProvider';

const { FiMusic, FiX, FiUser } = FiIcons;

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthContext();
  
  // 隱藏 Navbar 的頁面
  const hiddenPages = ['/', '/login', '/register', '/profile'];
  if (hiddenPages.includes(location.pathname)) return null;

  return (
    <nav className="fixed top-0 left-0 w-full z-50 px-8 py-10 flex justify-between items-center pointer-events-none">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="pointer-events-auto"
      >
        <span className="text-amber-500/80 font-serif tracking-[0.4em] text-sm cursor-default">M.B.</span>
      </motion.div>

      <div className="flex items-center space-x-10 pointer-events-auto">
        <motion.button
          whileHover={{ scale: 1.1, color: '#F59E0B' }}
          className="text-gray-500 transition-colors"
        >
          <SafeIcon icon={FiMusic} className="text-lg" />
        </motion.button>

        {/* 帳戶按鈕 */}
        {user && (
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate('/profile')}
            className="group flex items-center space-x-3 text-gray-500 hover:text-white transition-all duration-500"
          >
            <span className="text-[10px] tracking-[0.3em] uppercase opacity-0 group-hover:opacity-100 transition-opacity">
              {user.name || 'Account'}
            </span>
            <div className="p-2 rounded-full border border-white/5 group-hover:border-amber-500/30 transition-colors">
              <SafeIcon icon={FiUser} className="text-sm" />
            </div>
          </motion.button>
        )}

        {/* 推門離開 */}
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/')}
          className="group flex items-center space-x-3 text-gray-500 hover:text-white transition-all duration-500"
        >
          <span className="text-[10px] tracking-[0.3em] uppercase opacity-0 group-hover:opacity-100 transition-opacity">Exit Bar</span>
          <div className="p-2 rounded-full border border-white/5 group-hover:border-amber-500/30 transition-colors">
            <SafeIcon icon={FiX} className="text-sm" />
          </div>
        </motion.button>
      </div>
    </nav>
  );
};

export default Navbar;